import { RegistrationFormScreens } from "app/utils/const";
import { useState } from "react";
import { injectIntl, IntlShape } from "react-intl";
import "./AccountDetails.scss";
import Email from "./components/Email/Email";
import NextStepButton from "./components/NextStepButton/NextStepButton";
import Password from "./components/Password.tsx/Password";
import Username from "./components/Username/Username";

type AccountDetailsProps = {
  intl: IntlShape;
  username: string;
  email: string;
  password: string;
  handleChange: (id: string, value: string | boolean) => void;
  setSelectedScreen: (selectedScreen: string) => void;
  selectedScreen: string;
};

const AccountDetails = (props: AccountDetailsProps): JSX.Element => {
  const [usernameValidated, setUsernameValidated] = useState(false);
  const [emailValidated, setEmailValidated] = useState(false);
  const [passwordValidated, setPasswordValidated] = useState(false);

  if (props.selectedScreen === RegistrationFormScreens.ACCOUNT_DETAILS) {
    return (
      <div className="registration-form-modal__account-details">
        <div className="form-details">
          <Username
            intl={props.intl}
            username={props.username}
            handleChange={props.handleChange}
            usernameValidated={usernameValidated}
            setUsernameValidated={setUsernameValidated}
          />
          <Email
            intl={props.intl}
            email={props.email}
            handleChange={props.handleChange}
            emailValidated={emailValidated}
            setEmailValidated={setEmailValidated}
          />
          <Password
            intl={props.intl}
            password={props.password}
            handleChange={props.handleChange}
            passwordValidated={passwordValidated}
            setPasswordValidated={setPasswordValidated}
          />
        </div>
        <NextStepButton
          usernameValidated={usernameValidated}
          emailValidated={emailValidated}
          passwordValidated={passwordValidated}
          setSelectedScreen={props.setSelectedScreen}
        />
      </div>
    );
  }
};

export default injectIntl(AccountDetails);
